import { render, staticRenderFns } from "./dataQueryTemplate2.vue?vue&type=template&id=ae9d4d60&scoped=true"
import script from "./dataQueryTemplate2.vue?vue&type=script&lang=js"
export * from "./dataQueryTemplate2.vue?vue&type=script&lang=js"
import style0 from "./dataQueryTemplate2.vue?vue&type=style&index=0&id=ae9d4d60&prod&scoped=true&lang=css"
import style1 from "./dataQueryTemplate2.vue?vue&type=style&index=1&id=ae9d4d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9d4d60",
  null
  
)

export default component.exports